import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { useRef, useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import Constants from "../../../../utils/Constants";
import UIkit from "uikit";
import './InvoiceShow.css';
const InvoiceShow = ({
  BankInvoice,
  bookingFee,
  bankdata,
  orderData,
  bankName,
  slipType,
}) => {



  // console.log(slipType , "slipType")

  const [invoiceloader, setinvoiceloader] = useState(false);
  const [loader , setloader] = useState(false)

  const transactions = orderData.transaction;
  // only the paid Transactions amount will be added to sum table
  const transaction_amount = transactions.map((item) =>
    item.status === "Paid" ? item.amount : 0
  );

  const totaltransactionAmount = transaction_amount.reduce(
    (accumulator, currentAmount) => {
      return parseInt(accumulator) + parseInt(currentAmount);
    },
    0
  );

  // calculates the total Amount Receivable from transactions and prices

  const ReceveivableAmount = new Intl.NumberFormat("en-PK", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(
    parseInt(orderData.details.variant.colorComboPrice) +
      parseInt(orderData.details.variant.variantPrice) +
      parseInt(orderData.details?.vehicleDelivery?.freightCharges || 0) -
      totaltransactionAmount || 0
  );

  



  


  // this lines parses the int 8,757,658 removes comas and return single int to use in covert numbertowords function

  const parsedAmount = Number(ReceveivableAmount.replace(/,/g, ""));

  const InvoiceRef = useRef();

  const generateMultiPagePDF = async () => {
    setloader(true)
    const content = InvoiceRef.current;

    setTimeout(async () => {
      try {
        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // Capture the HTML content
        const canvas = await html2canvas(content, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/jpeg", 0.75);
        const imgHeight = (canvas.height * pageWidth) / canvas.width;

        // Add the content three times
        for (let i = 1; i <= 3; i++) {
          if (i > 1) pdf.addPage();
          pdf.addImage(
            imgData,
            "JPEG",
            0,
            0,
            pageWidth,
            imgHeight,
            undefined,
            "FAST"
          );
          pdf.setFontSize(6);
          pdf.text(`Page ${i} of 3`, pageWidth - 20, pageHeight - 10);
        }

        // Add the 4th page with the static image
        if (bankdata.name === "Meezan Bank") {
          pdf.addPage(); // Add the 4th page
          const staticImageURL = "/images/meezan-terms-and-conditions.png"; // Path to your static image
          const staticImageBlob = await fetch(staticImageURL).then((res) =>
            res.blob()
          );

          const staticImage = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.readAsDataURL(staticImageBlob);
          });

          // Add the static image to the PDF after loading
          await new Promise((resolve) => {
            const img = new window.Image();
            img.src = staticImage;

            img.onload = () => {
              const imgOriginalWidth = img.width;
              const imgOriginalHeight = img.height;

              // Calculate aspect ratio
              const aspectRatio = imgOriginalWidth / imgOriginalHeight;

              // Define dimensions for the PDF
              let pdfImgWidth = pageWidth; // Full width of the PDF page
              let pdfImgHeight = pageWidth / aspectRatio; // Adjust height based on aspect ratio

              if (pdfImgHeight > pageHeight) {
                pdfImgHeight = pageHeight;
                pdfImgWidth = pageHeight * aspectRatio;
              }

              const xOffset = (pageWidth - pdfImgWidth) / 2;
              const yOffset = (pageHeight - pdfImgHeight) / 2;

              // Add the static image to the 4th page
              pdf.addImage(
                img,
                "JPEG",
                xOffset,
                yOffset,
                pdfImgWidth,
                pdfImgHeight
              );
              resolve(); // Resolve after image is added
            };

            img.onerror = () => {
              console.error("Error loading image.");
              resolve(); // Resolve even if the image fails to load
            };
          });
        }

        // Save the PDF
        const pdfBlob = pdf.output("blob");
        if (pdfBlob.size > 5 * 1024 * 1024) {
          alert("File size exceeds 5MB. Further compression is needed.");
        } else {
          pdf.save("Invoice_" + new Date().toLocaleString() + ".pdf");
          const formData = new FormData();
          formData.append(
            "invoice",
            pdfBlob,
            "invoice_" + new Date().toLocaleString() + ".pdf"
          );

          if(slipType === 'final'){
            formData.append(
              'secondInvoiceNo' , BankInvoice
            )
          }
          else{
            formData.append(
              'InvoiceNo' , BankInvoice
            )
          }



          SubmitInvoice(formData);
        }
      } catch (error) {
        console.error("Error generating PDF:", error);
      }
    }, 100);
  };

  // Helper function to load an image for PDF
  const loadImage = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = url;
      img.crossOrigin = "Anonymous"; // Allow CORS for cross-origin images
      img.onload = () => resolve(img); // Resolve the image element
      img.onerror = (err) => reject(err); // Reject on error
    });
  };

  const SubmitInvoice = (value) => {
    setinvoiceloader(true);
    axios({
      method: "patch",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      // data: data,
      data: value,
      url: Constants.url + `${slipType === 'final' ? `orders/${orderData.id}/bankslip` : `orders/${orderData.id}/finalbankslip`}  `,
    })
      .then((res) => {
        // setinvoiceloader(false);
        if (res.data.status === "success") {
          window
            .swal({
              icon: "success",
              title: "Bank slip Uploaded",
            })
            .then(() => UIkit.modal(`#generate_invoice${orderData.id}`).hide());
        }
      })
      .catch((err) => {
        // setLoader(false);
      });

    // Api For Delivery Date
  };

  // const SentInvoiceEmail = () => {

  //   // setLoader(true);

  //   axios({
  //     method: "post",
  //     headers: {
  //       Authorization: `Bearer ${localStorage.getItem("token")}`,
  //     },
  //     // data: data,
  //     // data: value,
  //     url: Constants.url + `orders/send-pbo`,
  //   })
  //     .then((res) => {
  //       // setLoader(false);

  //       if (res.data.status === "success") {
  //         // UIkit.modal("#modal-media-image").hide()
  //         window
  //           .swal({
  //             icon: "success",
  //             title: "success",
  //           })

  //         // .then(() => summaryrefetch());
  //         // refetch()
  //       }
  //     })
  //     .catch((err) => {
  //       // setLoader(false);
  //     });
  // };

  function numberToWords(num) {
    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    function convertHundreds(num) {
      let result = "";
      if (num > 99) {
        result += ones[Math.floor(num / 100)] + " Hundred ";
        num = num % 100;
      }
      if (num > 19) {
        result += tens[Math.floor(num / 10)] + " ";
        num = num % 10;
      }
      if (num > 0) {
        result += ones[num] + " ";
      }
      return result.trim();
    }

    if (num === 0) return "zero";

    let result = "";

    if (num >= 1000000) {
      result += convertHundreds(Math.floor(num / 1000000)) + " Million ";
      num = num % 1000000;
    }

    if (num >= 1000) {
      result += convertHundreds(Math.floor(num / 1000)) + " Thousand ";
      num = num % 1000;
    }

    result += convertHundreds(num);

    return result.trim();
  }

  return (
    <div className="  ">
      <div className={``}>
        {/* <Image
          className="img-fluid img-overlay"
          src="/images/byd-white.svg"
          alt=""
          title=""
          width={300}
          height={300}
        /> */}
      </div>
      <main className="thankyou bank">
        <div className="thankyouinner">
          <Container>
            <Row className="justify-content-center">
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={{ span: 8 }}
                xl={{ span: 8 }}
                xxl={{ span: 8 }}
                className=""
              >
                <div className="thankyoudetail">
                  {/* <svg
                  width="54"
                  height="54"
                  viewBox="0 0 54 54"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M35.9591 18.7773C36.5727 18.0409 37.8 17.9182 38.5364 18.5318C39.2727 19.1455 39.3955 20.3727 38.7818 21.1091L26.5091 35.7136C25.8955 36.45 24.6682 36.5727 23.9318 35.9591L15.9545 29.3318C15.2182 28.7182 15.0955 27.4909 15.7091 26.7545C16.3227 26.0182 17.55 25.8955 18.2864 26.5091L24.9136 32.0318L35.9591 18.7773ZM27 54C12.0273 54 0 41.9727 0 27C0 12.0273 12.0273 0 27 0C41.9727 0 54 12.0273 54 27C54 41.9727 41.9727 54 27 54ZM27 51.5455C40.5 51.5455 51.5455 40.5 51.5455 27C51.5455 13.5 40.5 2.45455 27 2.45455C13.5 2.45455 2.45455 13.5 2.45455 27C2.45455 40.5 13.5 51.5455 27 51.5455Z"
                    fill="#333333"
                  />
                </svg>
                <h3>Payment Successful </h3> */}
                  {/* <h2>Thank you for choosing BYD</h2> */}
                  {/* <p>Booking ID: {orderData?.orderNo || '-'}</p> */}
                  {/* {isBankSlipLoaded && (
                  <>
                    <div className="spinner-border bank-slip-spinner" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <h4 className="bank-slip-text">
                      Please wait while your bank slip is being generated
                    </h4>
                  </>
                )} */}
                  <div className="invoice">
                    <div className="table-responsive" ref={InvoiceRef}>
                      
                      <table style={{ borderBottom: "2px solid #000" }}>
                        <tbody>
                          <tr className="uk-flex uk-flex-center uk-flex-middle" > 
                            <th style={{ textAlign: "right", width: "20%" }}>
                              <Image
                                src={"/images/byd.webp"}
                                alt=""
                                title=""
                                className="img-fluid"
                              />
                            </th>
                            <th style={{ width: "60%", textAlign: "center" }}>
                              <b>
                                <h3>Transact</h3>
                              </b>
                              <p>Transaction Banking Service</p>
                              <p>
                                Transaction to be Processed through{" "}
                                {bankdata?.bank_service_name} only
                              </p>
                              <b>
                                <h3>Deposit Slip</h3>
                              </b>
                            </th>
                            <th style={{ textAlign: "left", width: "20%" }}>
                              {bankdata.name === "Meezan Bank" && (
                                <Image
                                  src={"/images/meezanbank.png"}
                                  alt=""
                                  title=""
                                  className="img-fluid"
                                />
                              )}
                              {bankdata.name === "HBL Bank" && (
                                <Image
                                  src={"/images/hbl.jpg"}
                                  alt=""
                                  title=""
                                  className="img-fluid"
                                />
                              )}
                            </th>
                          </tr>
                        </tbody>

                      <div style={{ backgroundColor: "" }}>
                        <h6 style={{ textAlign: "right" }}>
                          {/* validity for 7 days */}
                          Validity : 
                          {new Date(new Date().getTime() + 9 * 24 * 60 * 60 * 1000).toLocaleDateString("en-GB")}
                          </h6>
                      </div>

                      </table>


                      <table className="infodiv">
                        <tbody>
                          <tr>
                            <th style={{ width: "15%" }}>
                              <h5>Date:</h5>
                              <h5>Account Title:</h5>
                              {/* <h5>Customer Name:</h5> */}
                              <h5>
                                {orderData.details.customerInfo.type ===
                                "corporate"
                                  ? "Company Name:"
                                  : "Customer Name:"}
                              </h5>
                              <h5>CNIC</h5>
                            </th>
                            <th style={{ width: "40%" }}>
                              <h5>
                                {/* {convertDate(
                                  orderData?.data?.orderDetails?.updatedAt
                                )} */}
                                {new Date().toLocaleDateString("en-GB")}
                              </h5>
                              <h5>{bankdata?.accountTitle || "-"}</h5>

                              <h5 style={{ textTransform: "capitalize" }}>
                                {orderData.details.customerInfo.type ===
                                "corporate"
                                  ? orderData?.details?.customerInfo
                                      ?.organizationName
                                  : orderData?.details?.customerInfo?.fullname}
                              </h5>

                              {/* <h5 style={{ textTransform: "capitalize" }}>
                                {orderData?.data?.customerDetails?.fullname}
                              </h5> */}
                              {/* <h5>{orderData?.data?.customerDetails?.cnic}</h5> */}
                              <h5>
                                {orderData.details.customerInfo.cnic || "-"}
                              </h5>
                            </th>

                            <th style={{ width: "20%" }}>
                              <h5>Deposit Slip No</h5>

                              <h5>
                                {bankdata.name === "Meezan Bank" ? "Customer Code" :  "Account No"  }
                                {/* {bankName === "HBL Bank" && "Account No"} */}
                              </h5>
                              <h5>Booking ID</h5>
                              <h5>{orderData.details.customerInfo.type === "corporate" ? "NTN" : "CNIC"}</h5>
                            </th>
                            <th style={{ width: "40%" }}>
                              {/* <h5>: {slipNoData?.pboField}</h5> */}
                              <h5>
                                :{" "}
                                {
                                  // orderData?.data?.orderDetails?.banks
                                  //   ?.accountNumber
                                  BankInvoice || "-"
                                }
                              </h5>

                              <h5>
                              :{" "}
                                {bankdata.accountNumber
                                  ? bankdata.accountNumber
                                  : "-"}
                              </h5>

                              <h5>: {orderData?.orderNo}</h5>
                              {/* <h5>: {orderData?.data?.customerDetails?.ntn}</h5> */}
                              <h5>
                                :{" "}
                                {orderData.details.customerInfo.type ===
                                "corporate"
                                  ? orderData?.details?.customerInfo?.ntn
                                  : orderData?.details?.customerInfo?.cnic ||
                                    "-"}
                              </h5>
                            </th>
                          </tr>
                        </tbody>
                      </table>

                      <table
                        className="InstrumentSec"
                        style={{ border: "1px solid #000" }}
                      >
                        <tbody>
                          <tr>
                            <th
                              style={{
                                width: "20%",
                                backgroundColor: "#E7E6E6",
                                padding: "5px 10px",
                              }}
                            >
                              <h5>Instrument Type</h5>
                            </th>
                            <th
                              style={{
                                width: "20%",
                                backgroundColor: "#E7E6E6",
                                padding: "5px 10px",
                              }}
                            >
                              <h5>Instrument #</h5>
                            </th>

                            <th
                              style={{
                                width: "20%",
                                backgroundColor: "#E7E6E6",
                                padding: "5px 10px",
                              }}
                            >
                              <h5>Instrument Date</h5>
                            </th>
                            <th
                              style={{
                                width: "20%",
                                backgroundColor: "#E7E6E6",
                                padding: "5px 10px",
                              }}
                            >
                              <h5>Instrument Bank</h5>
                            </th>
                            <th
                              style={{
                                width: "20%",
                                backgroundColor: "#E7E6E6",
                                padding: "5px 10px",
                              }}
                            >
                              <h5>Amount</h5>
                            </th>
                          </tr>
                        </tbody>
                      </table>

                      <table
                        className="InstrumentSecDetail"
                        style={{
                          border: "1px solid #000",
                          borderTop: "none",
                        }}
                      >
                        <tbody>
                          <tr>
                            <th style={{ width: "20%" }}>
                              <h5>Pay Order</h5>
                            </th>
                            <th style={{ width: "20%" }}></th>

                            <th style={{ width: "20%" }}></th>
                            <th style={{ width: "20%" }}></th>
                            <th style={{ width: "20%" }}>
                              <h5>
                                {/* {bookingFee
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "} */}
                                {ReceveivableAmount}
                                PKR
                              </h5>
                            </th>
                          </tr>
                        </tbody>
                      </table>

                      <table className="InstrumentSecTtaol">
                        <tbody>
                          <tr>
                            <th style={{ width: "20%" }}></th>
                            <th style={{ width: "20%" }}></th>
                            <th style={{ width: "20%" }}></th>
                            <th style={{ width: "20%" }}>
                              <h5>Total Amount</h5>
                            </th>
                            <th style={{ width: "20%" }}>
                              <h5>
                                {/* {bookingFee
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "} */}
                                {ReceveivableAmount}
                                PKR
                              </h5>
                            </th>
                          </tr>
                        </tbody>
                      </table>

                      <table>
                        <tbody>
                          <tr>
                            <th style={{ textAlign: "left" }}>
                              <p style={{ lineHeight: "20px" }}>
                                All Pay Orders/Demand Drafts being prepared for
                                booking of BYD vehicles should be in the name of
                                Mega Motor Company (Private) Limited.
                              </p>
                              <p>
                                Amount in words:
                                {numberToWords(parsedAmount)} rupees only.
                              </p>
                            </th>
                          </tr>
                          {/* <tr>
                          <th style={{ textAlign: "left" }}>
                            <p style={{ lineHeight: "20px" }}>
                              **All Pay Orders/Demad Drafts/Manager's Cheques
                              being prepared for booking of BYD vehicles should
                              be in the name of Mega Motor Company (Private)
                              Limited
                            </p>
                          </th>
                        </tr> */}
                          <tr>
                            <th style={{ textAlign: "left" }}>
                              <h3
                                style={{
                                  lineHeight: "20px",
                                  fontWeight: "600",
                                  margin: 0,
                                }}
                              >
                                Mandatory fields
                              </h3>
                            </th>
                          </tr>
                        </tbody>
                      </table>

                      <table
                        className="InstrumentSecTtaol"
                        style={{ marginTop: "10px" }}
                      >
                        <tbody>
                          <tr>
                            <th style={{ width: "13%" }}>
                              <h5>Depositor Name</h5>
                            </th>
                            <th
                              style={{
                                width: "18%",
                                border: " 1px solid #000",
                                height: "40px",
                              }}
                            >
                              <h5></h5>
                            </th>
                            <th style={{ width: "14%" }}>
                              <h5>Depositor CNIC</h5>
                            </th>
                            <th
                              style={{
                                width: "20%",
                                border: " 1px solid #000",
                                height: "40px",
                              }}
                            >
                              <h5></h5>
                            </th>
                            <th style={{ width: "15%" }}>
                              <h5>Depositor Cell No </h5>
                            </th>
                            <th
                              style={{
                                width: "22%",
                                border: " 1px solid #000",
                                height: "40px",
                              }}
                            >
                              <h5></h5>
                            </th>
                          </tr>
                        </tbody>
                      </table>

                      <table
                        className="InstrumentSecTtaol"
                        style={{ margin: "30px 0" }}
                      >
                        <tbody>
                          <tr>
                            <th style={{ width: "15%"  }}>
                              <h5>
                                Purpose of Transaction : 
                              </h5>
                            </th>
                            <th
                              style={{
                                width: "25%",
                                border: " 1px solid #000",
                              }}
                            >
                              <h5>Purchase of Vehicle
                              (Balance Payment)</h5>
                            </th>
                            <th style={{ width: "25%"  }}>
                              <h5 style={{textAlign:"right"}} >Relationship with Account holder :</h5>
                            </th>
                            <th
                              style={{
                                width: "22%",
                                border: " 1px solid #000",
                              }}
                            >
                              <h5></h5>
                            </th>
                          </tr>
                        </tbody>
                      </table>

                      <table className="Signature" style={{ margin: "60px 0" }}>
                        <tbody>
                          <tr>
                            <th
                              style={{
                                textAlign: "center",
                                width: "155px",
                                display: "block",
                              }}
                            >
                              <span>___________________</span>
                              <p> Customer Signature</p>
                            </th>
                            <th style={{ textAlign: "right" }}>
                              <span>___________________</span>
                              <p>Bank Stamp & Signature</p>
                            </th>
                          </tr>
                        </tbody>
                      </table>

                      <table className="Signature">
                        <tbody>
                          <tr>
                            <th style={{ textAlign: "left" }}>
                              <p>
                                Bank Copy{" "}
                                <Image
                                  src={"/images/checkbox.png"}
                                  alt=""
                                  title=""
                                  className="img-fluid"
                                />
                              </p>
                            </th>
                            <th style={{ textAlign: "center" }}>
                              <p>
                                Customer Copy{" "}
                                <Image
                                  src={"/images/checkbox.png"}
                                  alt=""
                                  title=""
                                  className="img-fluid"
                                />
                              </p>
                            </th>
                            <th style={{ textAlign: "right" }}>
                              <p>
                                Beneficiary Copy{" "}
                                <Image
                                  src={"/images/checkbox.png"}
                                  alt=""
                                  title=""
                                  className="img-fluid"
                                />
                              </p>
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div
                  // className={`buttonbooking ${
                  //   isBankSlipLoaded ? "d-none" : ""
                  // }`}
                  >
                    <ul>
                      <li style={{ listStyle: "none" }}>


                        <button
                          disabled={invoiceloader}
                          type="button"
                          className="uk-button uk-button-secondary"
                          onClick={generateMultiPagePDF}
                        >
                          {loader ? (
                            <div uk-spinner="" className="loader"></div>
                          ) : (
                            "Download Slip"
                          )}
                        </button>

                        {/* <button
                          disabled={invoiceloader}
                          type="button"
                          className="uk-button uk-button-secondary"
                          onClick={generateMultiPagePDF}
                        >
                          DOWNLOAD SLIP
                        </button> */}
                      </li>
                      {/* <li>
                      <button type="button" className="btn-outline">
                        PRINT Deposit SLIP
                      </button>
                    </li> */}
                    </ul>
                  </div>
                </div>
                {/* <div className="thanyoutext">
                  <h4>How to Make a Payment via Pay Order</h4>
                  <p>
                    Payment is accepted only via Pay Order at all Habib Bank
                    Limited (HBL) and Meezan Bank branches.
                  </p>
                  <ul>
                    <li>
                      <b>Step 1: </b>
                      <span>
                        {" "}
                        Download the Bank Deposit Slip from the order
                        finalisation page or by logging into your profile.
                      </span>
                    </li>
                    <li>
                      <b>Step 2: </b>{" "}
                      <span>
                        Prepare a Pay Order payable to Mega Motor Company
                        (Private) Limited bank account.
                      </span>
                    </li>
                    <li>
                      <b>Step 3: </b>{" "}
                      <span>
                        Visit any HBL or Meezan Bank branch and submit both the
                        Pay Order and the bank deposit slip.
                      </span>
                    </li>
                    <li>
                      <b>Step 4: </b>{" "}
                      <span>
                        Mega Motors Company will issue a Provisional Booking
                        Order (PBO) within 2 working days of receiving the Pay
                        Order. You will receive the PBO via email, and it will
                        also be accessible from your profile.
                      </span>
                    </li>
                  </ul>
                  
                  <p>
                    Note: The PBO will be cancelled if payment is not received.
                  </p>
                </div> */}
              </Col>
            </Row>
          </Container>
        </div>
      </main>
    </div>
  );
};

export default InvoiceShow;
